import { IntentType } from '@40seas/entities/intents';
import { CurrentUser } from '@40seas/frontend/libs/entities';
import { FlowConfiguration, IntentCallbacks, PaymentContextType } from '@40seas/payments-shared';

export type OpenModalParams = {
    intentType: IntentType;
    intentPayload?: object;
    modalData?: PaymentContextType;
    tenant?: string;
    callbacks?: IntentCallbacks;
    configurationOverrides?: Partial<FlowConfiguration>;
    isEmbedded?: boolean;
    token?: string;
    user?: CurrentUser;
};

export type IntentData = { tenant?: string; token?: string; intent: PaymentContextType };

export type IntentParams = {
    intentType: IntentType;
    isLoading: boolean;
    isEmbedded?: boolean;
    data?: IntentData;
    callbacks?: IntentCallbacks;
    configurationOverrides?: Partial<FlowConfiguration>;
    token?: string;
    isAuthenticationEnabled?: boolean;
};

export type ModalStore = {
    openModal: (params: OpenModalParams) => void;
};

export const defaultModalStore: ModalStore = {
    openModal: () => {},
};
